/**
 * Frequency utility functions for frontend
 * Handles display labels for unified interval format
 */

export type Frequency = 'one-time' | 'semi-monthly' | 'interval';
export type IntervalUnit = 'days' | 'weeks' | 'months' | 'years';

/**
 * Get friendly label for frequency display
 */
export function getFrequencyLabel(
	frequency: Frequency | string | undefined | null,
	intervalCount: number | null | undefined = null,
	intervalUnit: IntervalUnit | string | null | undefined = null
): string {
	if (!frequency || frequency === 'one-time') return '';
	if (frequency === 'semi-monthly') return 'Semi-monthly';

	if (frequency === 'interval') {
		if (intervalCount && intervalUnit) {
			// Check for friendly labels (predefined intervals)
			if (intervalCount === 1 && intervalUnit === 'weeks') return 'Weekly';
			if (intervalCount === 2 && intervalUnit === 'weeks') return 'Biweekly';
			if (intervalCount === 1 && intervalUnit === 'months') return 'Monthly';
			if (intervalCount === 3 && intervalUnit === 'months') return 'Quarterly';
			if (intervalCount === 1 && intervalUnit === 'years') return 'Annual';

			// Custom intervals
			const unitLabel =
				intervalUnit === 'days'
					? 'day'
					: intervalUnit === 'weeks'
						? 'week'
						: intervalUnit === 'months'
							? 'month'
							: 'year';
			const plural = intervalCount > 1 ? `${unitLabel}s` : unitLabel;
			return `Every ${intervalCount} ${plural}`;
		}
		return 'Custom';
	}

	return 'Unknown';
}
